import { whoIsAthleteCoach } from "../../../utils/user-helpers";

export const startTraining = async ({ res, req, locals, api, flash }) => {
  const {
    athlete,
    activeUserToRequest,
    activeUser,
    coachOrganizationInformation = undefined,
  } = locals;

  const coachToRequestId =
    !!coachOrganizationInformation &&
    String(
      whoIsAthleteCoach(
        activeUser.athletes,
        athlete._id,
        activeUser._id,
        coachOrganizationInformation._id
      )
    ) !== String(activeUser._id)
      ? coachOrganizationInformation._id
      : activeUser._id;

  try {
    await api("activate-athlete", {
      method: "PUT",
      body: {
        toAthlete: athlete._id,
        coachToBillingId: activeUserToRequest._id,
        coachToRequestId,
      },
    });

    flash("success", `You have started training ${athlete.name}`);
    res.backDontScroll();
  } catch (e) {
    flash("error", e.message);
    res.backDontScroll();
  }
};
